import { render, staticRenderFns } from "./modalProductoInvitado.vue?vue&type=template&id=0df8811b&scoped=true&"
import script from "./modalProductoInvitado.vue?vue&type=script&lang=js&"
export * from "./modalProductoInvitado.vue?vue&type=script&lang=js&"
import style0 from "./modalProductoInvitado.vue?vue&type=style&index=0&id=0df8811b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8811b",
  null
  
)

export default component.exports